/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2021 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";
import { otheritemsreceiving } from '../../otheritems/otheritemsreceiving';
import { purchaseorderservice } from './purchaseorderservice';

export class purchaseorder extends IceEntity {
  purchase_order_key: string = "";
  from_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  from_trans_account: string = "";
  to_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  to_trans_account: string = "";
  purchase_note: string = "";
  purchase_order_number: string = "";
  total: number = 0.0;
  bill_status: IceTypes.trans_status = IceTypes.trans_status.isNone; // new 
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  purchase_from: string = "";

  ITEMS: otheritemsreceiving[] = [];
  SERVICES: purchaseorderservice[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "PURCHASE_ORDER";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ITEMS") return true;
    else if (ColumnName == "SERVICES") return true;
    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ITEMS") return "OTHER_ITEMS_RECEIVING";
    else if (ColumnName == "SERVICES") return "PURCHASE_ORDER_SERVICE";

    return null;
  }
}
